<script>
import {mapActions, mapMutations, mapState} from "vuex";
import CardStatisticsForDirectorCampus from '../../Cards/Commissions/CardStatisticsForDirectorCampus.vue'
import CardListStatementsV2 from '../../Cards/Commissions/CardListStatementsV2.vue'
import CardListDistributionPlaces from '../../Cards/Commissions/CardListDistributionPlaces.vue'
import CardDetailsPlaceHostel from '../../Cards/Commissions/CardDetailsPlaceHostel.vue'
import CardDetailsStatement from '../../Cards/Commissions/CardDetailsStatement.vue'
import WorkingWithOrders from "../../Tabs/TabsInConfDeanExWork/WorkingWithOrders.vue";
import CardListApplicants from "../../Cards/Commissions/CardListApplicants.vue";

export default {
  name: "SelectFacultyPlaces",
  props: {
    department_id: String
  },
  data: () => ({
    places_step: 1,
    statements_step: 1,
    select_stm_hostel_id: 0,
    select_room_id: 0,
    full_name_place: '',
    dialog_form_hostel_order: false
  }),
  components: {
    CardListApplicants,
    WorkingWithOrders,
    CardStatisticsForDirectorCampus,
    CardListStatementsV2,
    CardListDistributionPlaces,
    CardDetailsPlaceHostel,
    CardDetailsStatement
  },
  mounted() {
    this.GetObjectPlacesDormFac(this.department_id)
    this.GetStatementsForDepartment(this.department_id)
  },
  computed: {
    ...mapState({
      status_snackbar: state => state.interactionStatement.status_snackbar,
      errors: state => state.interactionStatement.errors
    }),
  },
  methods: {
    ...mapActions({
      GetObjectPlacesDormFac: 'placesInDormitories/GetObjectPlacesDormFac',
      GetStatementsForDepartment: 'interactionStatement/GetStatementsForDepartment',
      GetPlacesForSelect: 'placesInDormitories/GetPlacesForSelect',
      IndexOrder: 'hostelOrders/IndexOrder',
    }),
    ...mapMutations({
      setStatusSnackbar: 'interactionStatement/setStatusSnackbar',
    }),
    transitionPlaceDetails(params) {
      this.select_room_id = params.room_id
      this.places_step = 2
      this.full_name_place = params.full_name_place
    },
    transitionListPlaces() {
      this.places_step = 1
    },
    transitionStatementDetails() {
      this.GetPlacesForSelect(this.department_id)
      this.statements_step = 2
    },
    transitionListStatements() {
      this.statements_step = 1
    },
    setSelectCurrentStmHostel(props) {
      this.select_stm_hostel_id = props.stm_hostel_id
    },
    openDialogFormHostelOrder() {
      this.dialog_form_hostel_order = true

      this.IndexOrder(this.department_id)
    },
    closeDialogFormHostelOrder() {
      this.dialog_form_hostel_order = false
    }
  },
}
</script>

<template>
  <div>
    <v-dialog
        v-model="dialog_form_hostel_order"
        content-class="rounded-xl"
        class="rounded-xl"
        width="70%"
    >
      <WorkingWithOrders
          :department_id="department_id"
          @closeDialogFormHostelOrder="closeDialogFormHostelOrder"
      />
    </v-dialog>
    <v-snackbar
        max-width="400px"
        :value="status_snackbar"
        @input="setStatusSnackbar"
        :timeout="8000"
        rounded="xl"
        right
        top
        color="orange"
        outlined
    >
      <v-row no-gutters>
        <v-col cols="12" md="3">
          <v-icon
              color="orange"
              left
          >
            fa-exclamation-circle
          </v-icon>
        </v-col>
        <v-col cols="12" md="9">
          <div class="text-h6">
            {{ errors }}
          </div>
        </v-col>
      </v-row>
    </v-snackbar>
    <CardStatisticsForDirectorCampus/>
    <v-row>
      <v-col cols="12">
        <v-card
            outlined
            class="rounded-xl"
            width="100%"
        >
          <v-card-title>
            <v-spacer/>

            <v-btn
                @click="openDialogFormHostelOrder()"
                small
                rounded
                outlined
                color="teal"
            >
              Работа с приказами
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="5" class="d-flex">
        <v-window
            v-model="statements_step"
            style="width: 100%; height: 100%"
        >
          <v-window-item style="width: 100%; height: 100%" :value="1">
            <CardListStatementsV2
                :select_stm_hostel_id="select_stm_hostel_id"
                :department_id="department_id"
                @setSelectCurrentStmHostel="setSelectCurrentStmHostel"
                @transitionStatementDetails="transitionStatementDetails"
            />
          </v-window-item>
          <v-window-item style="width: 100%; height: 100%" :value="2">
            <CardDetailsStatement
                :select_stm_hostel_id="select_stm_hostel_id"
                :department_id="department_id"
                @transitionListStatements="transitionListStatements"
                @transitionListPlaces="transitionListPlaces"
            />
          </v-window-item>
        </v-window>
      </v-col>
      <v-col cols="12" md="7" class="d-flex">
        <v-window v-model="places_step" style="width: 100%">
          <v-window-item style="width: 100%" :value="1">
            <CardListDistributionPlaces
                @transitionPlaceDetails="transitionPlaceDetails"
            />
          </v-window-item>
          <v-window-item style="width: 100%" :value="2">
            <CardDetailsPlaceHostel
                :department_id="department_id"
                :select_room_id="select_room_id"
                :full_name_place="full_name_place"
                @transitionListPlaces="transitionListPlaces"
            />
          </v-window-item>
        </v-window>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>